module.exports = __webpack_public_path__ + "static/media/400286_02.6e3faea7.png";